import api from "./axios";

const systemEvaluationApi = {
  // Publik — untuk validator ahli (dokter, bidan, trainer, pakar IT)
  getItems: () => api.get("/system-evaluations/items"),
  submit: (payload) => api.post("/system-evaluations", payload),

  // Admin — rekap & daftar hasil
  getAll: (respondentType) =>
    api.get("/admin/system-evaluations", {
      params: respondentType ? { respondent_type: respondentType } : {},
    }),
  getSummary: () => api.get("/admin/system-evaluations/summary"),
  getById: (id) => api.get(`/admin/system-evaluations/${id}`),
};

export default systemEvaluationApi;
